import { OrganisationModel } from '@steelbuy/ts-shared';

import { createEntityDataContext } from '../../util/provider/EntityDataProvider';

export const OrganisationEntityData = createEntityDataContext<OrganisationModel>();
